import rimg from '@pixelunion/rimg-shopify'; // eslint-disable-line
import AsyncView from 'shopify-asyncview';
import CurrencyConverter from 'shopify-currency-converter';

export default class StaticProductRecommendations {
  constructor(section) {
    this.section = section;
    this.productId = section.data.productId;
    this.limit = section.data.settings.limit;

    this.recommendationContainer = document.querySelector('[data-product-recommendations]');

    this.recommendUrl = `/recommendations/products?section_id=static-product-recommendations&limit=${this.limit}&product_id=${this.productId}`;

    this._loadRecommendations();
  }

  _loadRecommendations() {
    AsyncView.load(
      this.recommendUrl,
    ).done(({ html }) => {
      this.recommendationContainer.innerHTML = html;

      rimg.watch(this.recommendationContainer);

      const productItems = this.recommendationContainer.querySelectorAll('[data-product-item]');

      if (productItems.length) {
        const moneyItems = this.recommendationContainer.querySelectorAll('.money');
        moneyItems.forEach(money => CurrencyConverter.update(money));

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }
    });
  }
}
